const M = [
  {
    name: "payPsd",
    zh: "支付密码",
    en: "Payment password"
  },
  {
    name: "SetPayPsd",
    zh: "设置支付密码",
    en: "Set payment password"
  },
  {
    name: "SetPayPsdTips",
    zh: "请设置您的支付密码用于后期的话费等支付消费",
    en: "Please set your payment password for payment and consumption"
  },
  {
    name: "ConfirmPayPsd",
    zh: "确认支付密码",
    en: "Confirm payment password"
  },
  {
    name: "ConfirmPayPsdTips",
    zh: "请再次输入您的支付密码并牢记您的支付密码",
    en: "Enter your payment password again and remember your payment password"
  },
  {
    name: "modifyPayPsd",
    zh: "修改支付密码",
    en: "Modify payment password"
  },
  {
    name: "enterPayPsd",
    zh: "请输入您的支付密码",
    en: "Enter your payment password"
  },
  {
    name: "enterOldPayPsd",
    zh: "请输入您的旧支付密码",
    en: "Enter your old payment password"
  },
  {
    name: "VerifyPayPsd",
    zh: "验证支付密码",
    en: "Verify payment password"
  },
  {
    name: "forgotPayPsd",
    zh: "忘记支付密码",
    en: "Forget payment password"
  },
  {
    name: "loginPsd",
    zh: "登录密码",
    en: "Login password"
  }
];

export default M;
